import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { VoucherService } from '@services/voucher.service';
import { environment } from '@environments/environment';
import { InitService } from '@services/init.service';
import { SelectOption } from '@shared/components/select/select-options';

@Component({
  selector: 'besafe-voucher-activation',
  templateUrl: './voucher-activation.component.html',
  styleUrls: ['./voucher-activation.component.scss']
})
export class VoucherActivationComponent implements OnInit {
  public voucherActivationForm: FormGroup;
  public isActivated = false;
  public errorMessage: string;
  public userExist = false;
  public codesOptions: SelectOption[] = [];

  constructor(
    public initService: InitService,
    private fb: FormBuilder,
    private voucherService: VoucherService
  ) { }

  ngOnInit() {
    this.voucherActivationForm = this.initForm();
    this.codesOptions = this.initService.formCodesOptions();
  }

  public applyCode(formData) {
    const voucherData = {
      phoneNumber: formData.code + formData.phone,
      couponCode: formData.couponCode
    };
    this.voucherService.voucherReserve(voucherData).subscribe(res => {
      console.log(res);
      this.isActivated = true;
      this.userExist = res.userExist;
    }, err => {
      this.isActivated = false;
      this.errorMessage = err.message;
    });
  }

  private initForm(): FormGroup {
    return this.fb.group({
      // phoneNumber: ['', Validators.required],
      code: ['', Validators.required],
      phone: ['', Validators.required],
      couponCode: ['', Validators.required],
      // couponsApiKey: [environment.couponsApiKey, Validators.required]
    });
  }

}
